// Utils
import { getAcl, getInboxState, getIsPublicEditEnabled } from '../../../common/elements/utils/elementPropertyUtils';
import { InboxState } from '../../../common/boards/boardConstants';
import { isRealUserId } from '../../../common/users/userHelper';
import { isAccessDenied } from '../../../common/permissions/permissionUtil';
import { prop } from '../../../common/utils/immutableHelper';
import * as Immutable from 'immutable';

const isInboxState = (inboxState) => (element) => getInboxState(element) === inboxState;

export const isInboxOpen = isInboxState(InboxState.OPEN);
export const isInboxClosed = isInboxState(InboxState.CLOSED);

export const getIsBoardShared = (element) => {
    if (getIsPublicEditEnabled(element)) return true;

    const acl = Immutable.Map(getAcl(element));
    if (!acl || !acl.size) return false;

    return acl.filter((v, userId) => isRealUserId(userId) && !isAccessDenied(prop(userId, acl))).size > 0;
};
